import { render } from "./HerinneringsjuwelenView.vue?vue&type=template&id=de60a9ac"
import script from "./HerinneringsjuwelenView.vue?vue&type=script&lang=js"
export * from "./HerinneringsjuwelenView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__